import styled from "styled-components";

const SettingLabel = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
`;

export default SettingLabel;
